<template>
  <div class="oauth-page">
    <div class="oauth-page__card">
      <i class="mdi mdi-loading mdi-spin"></i>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { persistAuthSession } from '@/api/auth'
import { notify } from '@/utils/notify'

export default {
  name: 'AuthCallback',
  data() {
    return {
      message: 'Входим...',
    }
  },
  mounted() {
    const query = this.$route.query || {}
    if (query.error) {
      this.message = String(query.error)
      notify(this.message, 'error')
      setTimeout(() => this.$router.replace('/kassa-login'), 1600)
      return
    }

    if (query.token) {
      persistAuthSession({
        token: query.token,
        role: query.role,
        company_role: query.company_role,
        can_manage_products: query.can_manage_products === '1' || query.can_manage_products === 'true' || query.can_manage_products === true,
        user_name: query.user_name,
        company_name: query.company_name,
        sale_mode: query.sale_mode,
      })
      notify('Вход выполнен')
      this.$router.replace('/cash')
      return
    }

    this.message = 'Не удалось войти'
    setTimeout(() => this.$router.replace('/kassa-login'), 1600)
  },
}
</script>

<style scoped>
.oauth-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f6f9fc;
  color: #152033;
}

.oauth-page__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 28px 32px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #d9e2ec;
}

.oauth-page__card i {
  font-size: 28px;
  color: #0b4f8a;
}
</style>
